import { signOut } from 'firebase/auth';
import { auth } from '../firebase';
import { useState } from 'react';

export function useLogout() {
  const [isLoggingOut, setIsLoggingOut] = useState(false);

  const logout = async () => {
    try {
      console.log('[DEBUG] useLogout - Iniciando signOut...');
      setIsLoggingOut(true);
      await signOut(auth);
      console.log('[DEBUG] useLogout - SignOut concluído com sucesso');
      // Mantém o loading por mais um momento para evitar flash
      await new Promise(resolve => setTimeout(resolve, 300));
    } catch (error) {
      console.error('[ERROR] useLogout - Erro no signOut:', error);
      setIsLoggingOut(false);
      throw error;
    }
  };

  return { logout, isLoggingOut };
}
